// © 2015-2021 WDNA - All Rights Reserved
import _ from 'lodash';

import api, { AxiosRequestConfig } from '../../services/api/Connect';

export type { AxiosRequestConfig };

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function authorization<T = any>(action: string, data?: any, options?: AxiosRequestConfig): Promise<T> {
  const root: string = 'auth';
  const form: AxiosRequestConfig = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
  switch (action) {
    case 'login':
      return api.post<T>(`${root}/login`, data, _.merge(options, form));
    case 'logout':
      return api.get<T>(`${root}/logout`, data, options);
    case 'myapps':
      return api.get<T>(`${root}/myapps`, data, options);
    case 'myinfo':
      return api.get<T>(`${root}/myinfo`, data, options);
    case 'password':
      return api.put<T>(`${root}/password`, data, _.merge(options, form));
    case 'users':
      return api.get<T>(`${root}/users`, data, options);
    case 'update':
      return api.post<T>(`${root}/save`, data, options);
    case 'areas':
      return api.get<T>(`${root}/areas`, data, options);
    case 'countries':
      return api.get<T>('lov/countries', data, options);
    default:
      return Promise.reject<T>(new Error(`Undefined action: ${action}`));
  }
}
